export class CategoryMap {
  static CATEGORY_MAP = {
    dispositius: 'Dispositius',
    ordinadors: 'Ordinadors',
    portatils: 'Portàtils',
    'all-in-one': 'All-in-one',
    tablets: 'Tablets',
    monitors: 'Monitors',
    serveiTecnic: 'Servei Tècnic',
    impresores: 'Impresores',
    impressores: 'Impressores',
    multifuncio: 'Multifunció',
    'impresores-injeccio-tinta': 'Impresores - Injecció Tinta',
    'impresores-laser': 'Impresores - Làser',
    'impresores-multifuncio-injeccio-tinta': 'Multifunció - Injecció Tinta',
    'impresores-multifuncio-laser': 'Multifunció - Làser',
    gaming: 'Gaming',
    reacondicionats: 'Reacondicionats',
    periferics: 'Perifèrics',
    cables: 'Cables i Xarxa',
    xarxa: 'Xarxa',
    teclats: 'Teclats',
    ratolins: 'Ratolins',
    altaveus: 'Altaveus',
    auriculars: 'Auriculars',
    'disc-durs-externs': 'Disc Durs externs',
    components: 'Components',
    'placa-base': 'Placa Base',
    memoria: 'Memoria',
    'targeta-grafica': 'Targeta Gràfica',
    'fonts-alimentacio': 'Fonts Alimentació',
    'discs-durs': 'Discs Durs',
    pendrives: 'Pendrives',
    'targetes-de-xarxa': 'Targetes de xarxa',
    routers: 'Routers',
    switchs: 'Switchs',
    'cables-de-xarxa': 'Cables de xarxa',
    software: 'Software',
    antivirus: 'Antivirus',
    'licencies-windows': 'Llicències Windows',
    'pack-office': 'Pack Office'
  };

  static getLabel(categoryKey) {
    if (!categoryKey) {
      return 'Categoria';
    }

    return this.CATEGORY_MAP[categoryKey] || categoryKey;
  }

  static getDisplayNames(categoryKeys = []) {
    return categoryKeys
      .filter(Boolean)
      .map((categoryKey) => this.getLabel(categoryKey));
  }

  static getOptions() {
    return Object.entries(this.CATEGORY_MAP).map(([key, label]) => ({
      key,
      label
    }));
  }

  static getKeys() {
    return Object.keys(this.CATEGORY_MAP);
  }
}

export const CATEGORY_MAP = CategoryMap.CATEGORY_MAP;
